var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlbumManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.album-manage{fill:#09a6a6;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "album-manage",
    d: "M400 840v-35h404v35H400Zm0-247v-35h404v35H400Zm0-246v-35h404v35H400ZM207.473 873q-21.086 0-36.279-15.19Q156 842.62 156 821.385q0-19.947 15.19-35.166Q186.38 771 207.615 771q19.947 0 35.166 15.809Q258 802.618 258 823.115q0 19.672-15.133 34.779Q227.734 873 207.473 873Zm0-247q-21.086 0-36.279-15.371Q156 595.257 156 574.885q0-19.085 15.369-34.485 15.368-15.4 36.95-15.4 19.469 0 34.575 15.515Q258 556.03 258 575.615T242.867 610.6Q227.734 626 207.473 626Zm-1.088-246q-19.585 0-34.985-15.371-15.4-15.372-15.4-35.744 0-19.085 15.371-34.485 15.372-15.4 36.244-15.4 19.585 0 34.985 15.515 15.4 15.515 15.4 35.1T242.547 364.6Q227.095 380 206.385 380Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbumManage);
export default __webpack_public_path__ + "static/media/album_manage.cf6756efbf06b71342b021b7d58159e6.svg";
export { ForwardRef as ReactComponent };